<script>

    import layer3d from "@/mixins/threeBoxLayer"

    export default{

        mixins:[layer3d],
        
        name:"arvore1",

        data(){
            return {
                loadDelay:0,
                modelName:"arvore1",
                modelDir:"/models3d/",
                rotation:[90,0,0,'ZXY'],
                scale:[15,15,15],
                zoomScaleFactor:[[9,10.7],[14,2],[15,1],[19,0.5]],
                coordinates: [-47.8288133263986,-15.702336959293092],
                throttleZoomUpdate:600, //
            }
        },

        computed:{

            geoJSON:function(){

                //list of main points
                var mainPoints = [
                    // [-47.83380719188227,-15.696316306063181],
                    // [-47.82757490208755,-15.696136282441415],
                    [-47.88404155604505,-15.734483162192362],
                    [-47.832875245080544,-15.70032326803333],
                    [-47.8289500033421,-15.702988306064398],
                    [-47.89291863349982,-15.791427313393271],
                    [-47.89215667010504,-15.789705646115166],
                    [-47.850791700295986,-15.770857331810504],
                    [-47.85585448944644,-15.760534728828588],
                    [-47.88407099254488,-15.803914057575],
                    [-47.88462472698666,-15.80233556045053],
                    [-47.873004953991455,-15.797085514295105],
                    [-47.8702985477039,-15.798168871023307],
                    [-47.868190663608516,-15.797927156297291],
                    [-47.8598485617201,-15.779837057438542],
                    [-47.8598485617201,-15.779837057438542],
                    [-47.890280407780295,-15.79098561922099],
                    [-47.83086392132162,-15.811861011287391],
                    [-47.838898214282864,-15.81902746537186],
                    [-47.84450912686626,-15.818366493294832],
                    [-47.84450912686626,-15.818366493294832],
                    [-47.84817208463457,-15.818921339206184],
                    [-47.85480808358693,-15.817720609990587],
                    [-47.85480808358693,-15.817720609990587],
                    [-47.87570732091885,-15.826794184608346],
                    [-47.876372705053456,-15.826355394992035],
                    [-47.87695211722598,-15.827034029098215],
                    [-47.87725490260891,-15.827336414331938],
                    [-47.80794869187511,-15.795993894828499],
                    [-47.80030992194216,-15.79693460704101],
                    [-47.79804931562691,-15.80011052804825],
                    [-47.84383738437981,-15.819548297417299],
                    [-47.843206500574354,-15.819717324626907],
                    [-47.84138426861057,-15.819645206363404],

                    //palacio-alvorada.vue
                    [-47.82353380053647,-15.792924725616786],
                    [-47.82448298371398,-15.792268051267428],
                    [-47.820125879822996,-15.793071610104647],
                    [-47.820236131986064,-15.791596527987735],

                    //clube do congresso
                    [-47.8335282356837,-15.772023290599108],
                    [-47.830910527890325,-15.77176382207199],
                    [-47.83389745723122,-15.76893314036937],

                    //asa noret
                    [-47.86622935782901,-15.75542425586562],
                    [-47.86737662055424,-15.753463415644347],
                    [-47.87014039175199,-15.752121663250449],
                    [-47.873079795745525,-15.74773500305993],

                    [-47.86320154785449,-15.81849225514074],

                    [-47.780725742139765,-15.792104303352161],
                    [-47.78117321697593,-15.798873914072502],
                    









                ]

                var points = [];

                _.each(mainPoints, pt=>{
                    points.push(pt)
                    for (let index = 0; index < _.random(1, 1); index++) {
                        var dist = 0.001;
                        var offsetX = _.random(-dist, +dist);
                        var offsetY = _.random(-dist, +dist);
                        points.push( [pt[0]+offsetX, pt[1]+offsetY])
                    }
                })


                var features = _.map(points, (point,index)=>{
                      
                      var scale = _.random(7,15); // (Math.random()*6)+9
                      
                      return  {
                        "type": "Feature",
                        "geometry": {
                            "type": "Point",
                            "coordinates":point
                        },
                        "properties":{
                            key:"arvore"+index+"three",
                            scale:[scale,scale,scale],//[5,5,5],
                            rotation:[90,0,Math.random()*360,'ZXY'],//[0,0,7,'XYZ'],
                            zoomScaleFactor:this.zoomScaleFactor,//[0,0,7,'XYZ'],
                        }
                    } 

                });

                
                console.log(features);

                return {
                    "type": "FeatureCollection",
                    "features": features
                }
            },
        },


        watch:{
            geoJSON:function(){

                // this.animatePoints(4, false)
            }
        },

        methods:{

        },

        style: function () {
            return {
                "type": "symbol",
                "layout": {
                    "icon-image": ["get", "icon"], //['case', ['==',['get','index'],0], 'largada','pis'],  //"pis",
                    "icon-anchor": "center",
                    "icon-allow-overlap": true,
                    "icon-size": {
                        "base": 1,
                        "stops": [
                            [8.9, 0.1],
                            [11, 0.5],
                            [14, 1.3]
                        ]
                    },
                },
                "paint": {
                    "icon-opacity": {
                        "base": 1,
                        "stops": [[11.3, 0], [11.4, 1]],
                    },
                }
            }
        }
    }


</script>